import { SEARCH_PAGE_SIZE } from "../constants/CommonConstants";
import { TESTING_EQUIPMENT_SEARCH_START_LOADING, TESTING_EQUIPMENT_SEARCH_END_LOADING, TESTING_EQUIPMENT_SEARCH_LOADED, SET_TESTING_EQUIPMENT_FILTER } from "../constants/IneTestingEquipmentConstants";
import { TESTING_EQUIPMENT_START_LOADING, TESTING_EQUIPMENT_END_LOADING, TESTING_EQUIPMENT_LOADED } from "../constants/IneTestingEquipmentConstants";

const initialState = {
    loading: false,
    list: {   
        dataList: []
        , searchList: []
        , totalCount: 0
    },
    filter: {
        pageIndex: 1,
        pageSize: SEARCH_PAGE_SIZE,
        search: "",
        active: ""
    },
    loadingFBO: false,
    fbo: null,
};

const IneTestingEquipmentReducer = (state = initialState, action) => {
    switch(action.type) {
        case TESTING_EQUIPMENT_SEARCH_START_LOADING:
            return {
                ...state,
                loading: true
            };
        case TESTING_EQUIPMENT_SEARCH_END_LOADING:
            return {
                ...state,
                loading: false
            };
        case TESTING_EQUIPMENT_SEARCH_LOADED:
            return {
                ...state,
                list: action.payload
            };
        case SET_TESTING_EQUIPMENT_FILTER:
            return {
                ...state,
                filter: action.payload
            };
        case TESTING_EQUIPMENT_START_LOADING:
            return {
                ...state,
                loadingFBO: true
            };
        case TESTING_EQUIPMENT_END_LOADING:
            return {
                ...state,
                loadingFBO: false
            };
        case TESTING_EQUIPMENT_LOADED:
            return {
                ...state,
                fbo: action.payload
            };
        default:
            return state;
    }
}

export default IneTestingEquipmentReducer;